import { connectRouter, routerMiddleware } from "connected-react-router";
import { applyMiddleware, combineReducers, createStore } from "redux";
import { ReducersMapObject } from "redux";
import { composeWithDevTools } from "redux-devtools-extension/developmentOnly";
import { createLogger } from "redux-logger";
import thunkMiddleware from "redux-thunk";
import lkfReducers from "@linkfluence/core/reducers";
import history from "./history";

const loggerMiddleware = () => {
  return createLogger({
    logger: console,
    collapsed: true,
    predicate() {
      return process.env.NODE_ENV === "development";
    },
  });
};

export default function (
  reducers?: ReducersMapObject,
  context?: Record<string, any>
) {
  const store = createStore(
    combineReducers({
      ...reducers,
      ...lkfReducers,
      router: connectRouter(history),
    }),
    composeWithDevTools(
      applyMiddleware(
        routerMiddleware(history),
        thunkMiddleware,
        loggerMiddleware()
      )
    )
  );
  return store;
}
